import './index.scss';
import { getFormattedTime } from '@zorba-shared/core/Services/textService';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'antd';
import { exportOffers, getOfferById } from '../../reducers/Offer/actions';
import OfferModal from '../OffersPage/Components/OfferModal';
import { useEffect } from 'react';

export default (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.computedMatch?.params?.dealSubmissionId) {
      dispatch(getOfferById(props.computedMatch?.params?.dealSubmissionId));
    }
  }, []);
  return (
    <Card div className="offer-view-page">
      <OfferModal />
    </Card>
  );
};
